// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from "react-router-dom";
// import logo from "../assets/logo.jpeg";
// import { FiMenu, FiClock } from 'react-icons/fi';

// const TopNav = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [productsOpen, setProductsOpen] = useState(false);
//   const location = useLocation();

//   const isActive = (path) => {
//     if (path === '/') return location.pathname === '/';
//     return location.pathname.startsWith(path);
//   };

//   const navLinks = [
//     { name: "Home", path: "/" },
//     { name: "About Us", path: "/about" },
//     { name: "Gallery", path: "/gallery" },
//     { name: "Enquiry", path: "/enquiry" },
//     { name: "Brochure", path: "/brochure" },
//     { name: "Contact", path: "/contact" },
//   ];

//   const products = [
//     { name: "Industrial Sheds", path: "/industrial-sheds" },
//     { name: "Fabrication Services", path: "/FabricationServices" },
//     { name: "Industrial Structures", path: "/IndustrialStructures" },
//     { name: "Prefabricated Buildings", path: "/pre-fab-structure-buildings" },
//     { name: "Steel Fabrication", path: "/structure-steel-fabrication" },
//     { name: "Roof & Wall Sheeting", path: "/roof-wall-sheeting" },
//   ];

//   const services = [
//     { name: 'PRE FAB STRUCTURES', path: '/pre-fab-structure-buildings' },
//     { name: 'STEEL FABRICATION', path: '/structure-steel-fabrication' },
//     { name: 'ROOF/WALL SHEETINGS', path: '/roof-wall-sheeting' }
//   ];

//   return (
//     <header className="sticky top-0 z-50 bg-white shadow-md">
//       {/* Top Bar */}
//       <div className="bg-primary text-white py-3">
//         <div className="max-w-7xl mx-auto px-4 flex flex-wrap justify-between items-center text-xs">
//           <ul className="flex flex-wrap gap-4 sm:gap-8 items-center">
//             {services.map((service, index) => (
//               <li key={service.name} className="flex items-center gap-3">
//                 {index > 0 && <span>|</span>}
//                 <Link
//                   to={service.path}
//                   className="font-semibold tracking-wider hover:text-secondary transition"
//                   aria-label={service.name}
//                 >
//                   {service.name}
//                 </Link>
//               </li>
//             ))}
//           </ul>
//           <div className="flex items-center gap-3 mt-2 sm:mt-0">
//             <FiClock className="text-lg" aria-hidden="true" />
//             <span>MON - SAT 09:00 - 19:00</span>
//           </div>
//         </div>
//       </div>

//       {/* Main Nav */}
//       <nav className="bg-white" role="navigation" aria-label="Main navigation">
//         <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
//           <Link to="/" aria-label="Vasavi Structures Home">
//             <img 
//               src={logo} 
//               alt="Vasavi Structures - Leading PEB Company in India" 
//               className="h-12 md:h-14" 
//               width="150"
//               height="56"
//             />
//           </Link>

//           {/* Desktop Menu */}
//           <div className="hidden xl:flex items-center gap-8">
//             {navLinks.slice(0, 2).map(link => (
//               <Link
//                 key={link.path}
//                 to={link.path}
//                 className={`font-montserrat font-semibold transition ${
//                   isActive(link.path) ? "text-secondary" : "text-gray-800 hover:text-primary"
//                 }`}
//                 aria-current={isActive(link.path) ? "page" : undefined}
//               >
//                 {link.name}
//               </Link>
//             ))}

//             {/* Products Dropdown */}
//             <div className="relative group">
//               <button 
//                 className="font-montserrat font-semibold text-gray-800 hover:text-primary flex items-center gap-1"
//                 aria-haspopup="true"
//                 aria-expanded="false"
//                 aria-label="Products menu"
//               >
//                 Products
//                 <svg className="w-4 h-4 group-hover:rotate-180 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                 </svg>
//               </button>
//               <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 bg-white shadow-xl rounded-xl border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
//                 {products.map(item => (
//                   <Link
//                     key={item.path}
//                     to={item.path}
//                     className="block px-6 py-3 text-sm hover:bg-gray-50 hover:text-primary transition"
//                     onClick={() => setProductsOpen(false)}
//                     aria-label={item.name}
//                   >
//                     {item.name}
//                   </Link>
//                 ))}
//               </div>
//             </div>

//             {navLinks.slice(2).map(link => (
//               <Link
//                 key={link.path}
//                 to={link.path}
//                 className={`font-montserrat font-semibold transition ${
//                   isActive(link.path) ? "text-secondary" : "text-gray-800 hover:text-primary"
//                 }`}
//                 aria-current={isActive(link.path) ? "page" : undefined}
//               >
//                 {link.name}
//               </Link>
//             ))}

//             <Link 
//               to="/enquiry" 
//               className="bg-secondary text-white px-6 py-3 rounded-lg font-bold hover:bg-secondary/90 transition"
//               aria-label="Get Quote from Vasavi Structures"
//             >
//               Get Quote
//             </Link>
//           </div>

//           {/* Mobile Toggle */}
//           <button
//             onClick={() => setIsOpen(!isOpen)}
//             className="xl:hidden text-gray-800 p-2"
//             aria-label={isOpen ? "Close menu" : "Open menu"}
//             aria-expanded={isOpen}
//             aria-controls="mobile-menu"
//           >
//             {isOpen ? (
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             ) : (
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//               </svg>
//             )}
//           </button>
//         </div>

//         {/* Mobile Menu */}
//         {isOpen && (
//           <div id="mobile-menu" className="xl:hidden border-t py-4 px-6 bg-white">
//             {navLinks.map(link => (
//               <Link
//                 key={link.path}
//                 to={link.path}
//                 className={`block py-3 font-semibold border-b ${isActive(link.path) ? "text-secondary" : "text-gray-800"}`}
//                 onClick={() => setIsOpen(false)}
//                 aria-current={isActive(link.path) ? "page" : undefined}
//               >
//                 {link.name}
//               </Link>
//             ))}
//             <div className="py-3">
//               <button
//                 onClick={() => setProductsOpen(!productsOpen)}
//                 className="w-full text-left font-bold text-primary flex justify-between items-center"
//                 aria-expanded={productsOpen}
//                 aria-label="Products menu"
//               >
//                 Products
//                 <svg className={`w-5 h-5 transition ${productsOpen ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                 </svg>
//               </button>
//               {productsOpen && (
//                 <div className="mt-3 pl-4 space-y-2">
//                   {products.map(item => (
//                     <Link
//                       key={item.path}
//                       to={item.path}
//                       className="block py-2 text-gray-700 hover:text-primary"
//                       onClick={() => { setIsOpen(false); setProductsOpen(false); }}
//                       aria-label={item.name}
//                     >
//                       {item.name}
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </div>
//             <Link
//               to="/enquiry"
//               className="block text-center bg-secondary text-white py-3 mt-4 rounded-lg font-bold"
//               onClick={() => setIsOpen(false)}
//               aria-label="Get Quote from Vasavi Structures"
//             >
//               Get Quote
//             </Link>
//           </div>
//         )}
//       </nav>
//     </header>
//   );
// };

// export default TopNav;























import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logoo.png";
import { FiClock, FiMail, FiPhone } from 'react-icons/fi';
import { business } from "../../config/business";

const TopNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [showTopBar, setShowTopBar] = useState(true);
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setShowTopBar(window.scrollY <= 60);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Industries", path: "/industries" },
    { name: "Locations", path: "/locations" },
    { name: "Resources", path: "/resources" },
    { name: "Gallery", path: "/gallery" },
    { name: "Projects", path: "/projects" },
    { name: "Contact", path: "/contact" },

  ];

  const products = [
    { name: "Industrial Sheds", path: "/industrial-sheds" },
    { name: "Fabrication Services", path: "/FabricationServices" },
    { name: "Industrial Structures", path: "/IndustrialStructures" },
    { name: "Prefabricated Buildings", path: "/pre-fab-structure-buildings" },
    { name: "Steel Fabrication", path: "/structure-steel-fabrication" },
    { name: "Roof & Wall Sheeting", path: "/roof-wall-sheeting" },
    { name: "PEB Warehouse", path: "/services/peb-warehouse" },
    { name: "PEB Factory Buildings", path: "/services/peb-factory-buildings" },
    { name: "PEB Erection", path: "/peb-erection" },
    { name: "Design & Engineering", path: "/design-engineering" },
    { name: "PEB Cost Calculator", path: "/peb-cost-calculator" },
  ];

  const services = [
    { name: 'PRE FAB STRUCTURES', path: '/pre-fab-structure-buildings' },
    { name: 'STEEL FABRICATION', path: '/structure-steel-fabrication' },
    { name: 'ROOF/WALL SHEETINGS', path: '/roof-wall-sheeting' }
  ];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
     {showTopBar && (
  /* Top Bar */
  <div className="bg-primary text-white py-3">
    <div className="max-w-7xl mx-auto px-4 flex flex-wrap justify-between items-center text-xs">
      <ul className="flex flex-wrap gap-4 sm:gap-8 items-center">
        {services.map((service, index) => (
          <li key={service.name} className="flex items-center gap-3">
            {index > 0 && <span>|</span>}
            <Link
              to={service.path}
              className="font-semibold tracking-wider hover:text-secondary transition"
              aria-label={service.name}
            >
              {service.name}
            </Link>
          </li>
        ))}
      </ul>
      <div className="flex flex-wrap items-center gap-6 mt-2 sm:mt-0">
        
        <div className="flex items-center gap-3">
          <FiMail className="text-lg" aria-hidden="true" />
          <a href={business.email.href} className="hover:text-secondary transition">
            {business.email.display}
          </a>
        </div>
        <div className="flex items-center gap-3">
          <FiPhone className="text-lg" aria-hidden="true" />
          <a href={business.phone.href} className="hover:text-secondary transition">
            {business.phone.display}
          </a>
        </div>
        <div className="flex items-center gap-3">
          <FiClock className="text-lg" aria-hidden="true" />
          <span>{business.hours}</span>
        </div>
      </div>
    </div>
  </div>
)}

      {/* Main Nav */}
      <nav className="bg-white" role="navigation" aria-label="Main navigation">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" aria-label="Vasavi Structures Home">
            <img 
              src={logo} 
              alt="Vasavi Structures - Leading PEB Company in India" 
              className="h-12 md:h-14" 
              width="150"
              height="56"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden xl:flex items-center gap-8">
            {navLinks.slice(0, 2).map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-montserrat font-semibold transition ${
                  isActive(link.path) ? "text-secondary" : "text-gray-800 hover:text-primary"
                }`}
                aria-current={isActive(link.path) ? "page" : undefined}
              >
                {link.name}
              </Link>
            ))}

            {/* Products Dropdown */}
            <div className="relative group">
              <Link
                to="/products"
                className="font-montserrat font-semibold text-gray-800 hover:text-primary flex items-center gap-1"
                aria-haspopup="true"
                aria-expanded="false"
                aria-label="View all products and services"
              >
                Products
                <svg className="w-4 h-4 group-hover:rotate-180 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </Link>
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 bg-white shadow-xl rounded-xl border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                {products.map(item => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className="block px-6 py-3 text-sm hover:bg-gray-50 hover:text-primary transition"
                    onClick={() => setProductsOpen(false)}
                    aria-label={item.name}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>

            {navLinks.slice(2).map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-montserrat font-semibold transition ${
                  isActive(link.path) ? "text-secondary" : "text-gray-800 hover:text-primary"
                }`}
                aria-current={isActive(link.path) ? "page" : undefined}
              >
                {link.name}
              </Link>
            ))}

            <Link 
              to="/enquiry" 
              className="bg-secondary text-white px-6 py-3 rounded-lg font-bold hover:bg-secondary/90 transition"
              aria-label="Get Quote from Vasavi Structures"
            >
              Get Quote
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="xl:hidden text-gray-800 p-2"
            aria-label={isOpen ? "Close menu" : "Open menu"}
            aria-expanded={isOpen}
            aria-controls="mobile-menu"
          >
            {isOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div id="mobile-menu" className="xl:hidden border-t py-4 px-6 bg-white">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-3 font-semibold border-b ${isActive(link.path) ? "text-secondary" : "text-gray-800"}`}
                onClick={() => setIsOpen(false)}
                aria-current={isActive(link.path) ? "page" : undefined}
              >
                {link.name}
              </Link>
            ))}
            <div className="py-3">
              <button
                onClick={() => setProductsOpen(!productsOpen)}
                className="w-full text-left font-bold text-primary flex justify-between items-center"
                aria-expanded={productsOpen}
                aria-label="Products menu"
              >
                Products
                <svg className={`w-5 h-5 transition ${productsOpen ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {productsOpen && (
                <div className="mt-3 pl-4 space-y-2">
                  {products.map(item => (
                    <Link
                      key={item.path}
                      to={item.path}
                      className="block py-2 text-gray-700 hover:text-primary"
                      onClick={() => { setIsOpen(false); setProductsOpen(false); }}
                      aria-label={item.name}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <Link
              to="/enquiry"
              className="block text-center bg-secondary text-white py-3 mt-4 rounded-lg font-bold"
              onClick={() => setIsOpen(false)}
              aria-label="Get Quote from Vasavi Structures"
            >
              Get Quote
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default TopNav;